<template>
  <div class="rel">
    <i
      v-if="hideRight"
      :class="showFixedRight ? 'icon-sf_menu-open' : 'icon-sf_menu-close'"
      class="fixed-table-hide icon"
      @click="hideFixedFunc('right')"
      :style="cornerStyle"
    ></i>
    <div
      class="fixed-table-container"
      :style="containerStyle"
      ref="content"
      :class="{ 'scroll-container': selfScroll, bold: bold }"
    >
      <div class="flex">
        <table
          v-if="isFixLeft"
          ref="leftClone"
          class="fixed-table table-clone left"
          :style="leftStyle"
        >
          <thead class="fixed-table corner" :style="cornerStyle" :class="[{ fixed: fixed.top }]">
            <slot name="leftThead"></slot>
          </thead>
          <tbody>
            <slot name="leftBody"></slot>
          </tbody>
        </table>
        <table ref="tbody" class="fixed-table  flex-grow" :style="bodyStyle">
          <thead ref="thead" :style="theadStyle" :class="[{ fixed: fixed.top }]">
            <slot name="thead"></slot>
          </thead>
          <tbody class="main-body">
            <slot name="tbody"></slot>
          </tbody>
        </table>
        <transition name="fade">
          <table
            v-if="isFixRight && showFixedRight"
            class="fixed-table table-clone right"
            :style="rightStyle"
            ref="rightClone"
          >
            <thead class="fixed-table corner" :style="cornerStyle" :class="[{ fixed: fixed.top }]">
              <slot name="rightThead"></slot>
            </thead>
            <tbody class="right-body">
              <slot name="rightBody"></slot>
            </tbody>
          </table>
        </transition>
      </div>
    </div>
    <scrollxbar v-if="selfScroll" :scroll-target="scrollTarget" :bold="bold"></scrollxbar>
  </div>
</template>

<script>
import scrollxbar from './scroll-x-bar'
import {
  addResizeEventListener,
  timerFnc,
  querySelectorAll,
  getStyle,
  getScrollTop,
  getScrollLeft,
} from './utils'
const userAgent = navigator.userAgent
const isMoz = /Firefox/.test(userAgent)
const isSafari = userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1
export default {
  components: {
    scrollxbar,
  },
  props: {
    offsetLeft: {
      type: [String, Number],
      default: 0,
    },
    offsetTop: {
      type: [String, Number],
      default: 0,
    },
    scrollTarget: {},
    useTrans: Boolean,
    selfScroll: {
      type: Boolean,
      default: false,
    },
    hideRight: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clientRect: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      targetOffset: {
        top: 0, // 距离
        left: 0, // 距离
      },
      // observer: {},
      fixed: {
        top: false, // 是否固定
        left: false, // 是否固定
        right: false,
      },
      resizeObserver: undefined, // resize的observer
      hoverObserver: undefined, // 用于绑定hover事件
      tbodyWidth: 0, // 表格宽度
      tleftWidth: 0, // 左侧表格宽度,
      tRightWidth: 0, // 右侧表格宽度,
      topChanging: false,
      leftChanging: false,
      opacity: 1,
      scrolling: false,
      iframe: {},
      theadLen: 1, // 保存表头行数，解决表头有多行时tr hover高亮的问题

      showFixedRight: true,
    }
  },
  computed: {
    theadStyle() {
      return {
        transform: `translate3d(0px, ${
          this.fixed.top && !this.topChanging ? -this.clientRect.top : 0
        }px, 1px)`,
      }
    },
    bodyStyle() {
      return {
        // marginLeft: '-1px',
        width: this.tbodyWidth + 'px',
        // width: this.tbodyWidth - (this.isFixLeft ? 1 : 0) + 'px',
        // position: 'relative',
        // left: '-1px'
      }
    },
    leftStyle() {
      return {
        transform: `translate3d(${
          this.fixed.left && !this.leftChanging ? this.offsetLeft - this.clientRect.left : 0
        }px, 0px, 0px)`,
        width: 'initial',
        opacity: !(this.offsetLeft - this.clientRect.left > this.tleftWidth) ? 1 : this.opacity,
      }
    },
    rightStyle() {
      const base = {
        transform: `translate3d(${this.leftChanging ? 0 : -this.clientRect.right}px, 0px, 0px)`,
        width: 'initial',
        // opacity: this.opacity
      }
      return base
    },
    cornerStyle() {
      return {
        transform: `translate3d(0px, ${
          this.fixed.top && !this.topChanging ? -this.clientRect.top : 0
        }px, 1px)`,
        // opacity: (this.topChanging || this.leftChanging) ? '0' : '1'
      }
    },
    containerStyle() {
      return {
        zIndex: this.scrolling ? '1' : '',
      }
    },
    scroller() {
      if (!this.scrollTarget) {
        return window
      }
      let result
      if (typeof this.scrollTarget === 'string') {
        result = document.querySelector(this.scrollTarget)
      } else {
        result = this.scrollTarget
      }
      if (result) {
        const pos = getStyle(result, 'position')
        if (pos !== 'absolute' && pos !== 'fixed') {
          result.style.position = 'relative'
        }
      }
      this.getTargetOffsetParent(this.$refs.content, result)
      return result
    },
    xScroller() {
      return this.$refs.content
    },
    isFixLeft() {
      return !!this.$slots.leftThead
    },
    isFixRight() {
      return !!this.$slots.rightThead
    },
    isTransition() {
      // return false;
      return isMoz || isSafari || this.useTrans
    },
  },
  mounted() {
    this.resizeObserver = new MutationObserver(this.observerHandle)
    this.init()
  },
  activated() {
    this.init()
    Array.from(document.querySelectorAll('tbody tr.hover')).forEach(each => {
      each.classList.remove('hover')
    })
  },
  deactivated() {
    this.destroyed()
  },
  beforeDestroy() {
    this.clientRect = {
      top: 0,
      left: 0,
      right: 0,
    }
    this.destroyed()
  },
  methods: {
    init() {
      // 获取表头行数
      this.theadLen = querySelectorAll('tr', this.$refs['thead']).length
      this.scroller.addEventListener('scroll', this.scrollHandle, false)
      if (this.selfScroll) {
        this.xScroller.addEventListener('scroll', this.scrollHandle, false)
      }
      if (this.selfScroll || this.scrollTarget) {
        this.iframe = addResizeEventListener(this.$refs.content, this.resizeHandel)
      } else {
        window.addEventListener('resize', this.resizeHandel, false)
      }
      this.resizeObserver.observe(this.$refs.content, {
        childList: true,
        subtree: true,
        characterData: true,
      })
      if (this.isFixLeft || this.isFixRight) {
        this.$el.addEventListener('mouseover', this.mouseOver, false)
        this.$el.addEventListener('mouseout', this.mouseLeave, false)
      }
      this.update()
    },
    destroyed() {
      this.scroller.removeEventListener('scroll', this.scrollHandle)
      if (this.selfScroll) {
        this.xScroller.removeEventListener('scroll', this.scrollHandle)
      }
      if (this.isFixLeft || this.isFixRight) {
        this.$el.removeEventListener('mouseover', this.mouseOver)
        this.$el.removeEventListener('mouseout', this.mouseLeave)
      }
      this.resizeObserver.disconnect()
      if (this.selfScroll || this.scrollTarget) {
        this.iframe.removeEventListener('resize', this.resizeHandel)
        this.iframe.remove()
      }
      window.removeEventListener('resize', this.resizeHandel)
    },
    hideFixedFunc(type) {
      if (type === 'right') {
        this.showFixedRight = !this.showFixedRight
      }
    },
    hoverClass(e, type) {
      const tr = e.target.closest('tr')
      if (!tr) {
        return
      }
      const idx = tr.rowIndex - this.theadLen + 1
      const trs = querySelectorAll(`tbody tr:nth-child(${idx})`, this.$el)
      if (trs.length === 0) {
        return
      }
      trs.forEach(each => {
        each.classList[type]('hover')
      })
    },
    mouseOver(e) {
      this.hoverClass(e, 'add')
    },
    mouseLeave(e) {
      this.hoverClass(e, 'remove')
    },
    getTargetOffsetParent(dom, parent) {
      let top = dom.offsetTop
      let left = dom.offsetLeft
      dom = dom.parentElement
      while (dom && dom !== parent) {
        top += dom.offsetTop
        left += dom.offsetLeft
        dom = dom.parentElement
      }
      this.targetOffset.left = left
      this.targetOffset.top = top
    },
    getPointOffsetParent() {
      const left = this.targetOffset.left
      const top = this.targetOffset.top
      let right =
        -this.scroller.clientWidth +
        this.tleftWidth +
        this.$refs.tbody.clientWidth +
        this.tRightWidth -
        this.scroller.scrollLeft
      if (right <= 0) {
        right = 0
      }
      return {
        top: top - (this.scrollTarget ? this.scroller.scrollTop : getScrollTop()),
        left: left - (this.scrollTarget ? this.scroller.scrollLeft : getScrollLeft()),
        right,
      }
    },
    scrollPositionInit() {
      const { left, top } = this.clientRect
      if (this.selfScroll) {
        this.$nextTick(() => {
          this.$refs.content.scrollLeft = -this.clientRect.left
        })
      } else if (this.scrollTarget) {
        this.$nextTick(() => {
          this.scroller.scrollLeft = -left
          this.scroller.scrollTop = -top
        })
      } else {
        scrollTo(left + this.tleftWidth, top)
      }
    },
    scrollerMouseWheel(e) {
      const scrollTarget = e.target.closest('.scroll-container')
      if (scrollTarget !== this.$refs.content && scrollTarget !== document.body) {
        return
      }

      if (scrollTarget === this.$refs.content) {
        e.preventDefault()
        let target
        if (this.scrollTarget) {
          target = this.scroller
        } else {
          target = document.scrollingElement
        }

        target.scrollTop += e.deltaY
        target.scrollLeft -= e.deltaX
      }
    },
    xScrollerMouseWheel(e) {
      e.preventDefault()
      this.xScroller.scrollLeft += e.deltaX
    },
    setScrollIng: timerFnc(function() {
      this.scrolling = false
    }, 250),
    scrollHandle() {
      const tbody = this.$refs.tbody
      if (!tbody) {
        return
      }
      this.scrolling = true
      this.setScrollIng()
      if (this.selfScroll) {
        let rightLength = this.$refs.rightClone ? this.$refs.rightClone.clientWidth : 0
        const content = this.$refs.content
        const { top } = tbody.getBoundingClientRect()
        const left = -content.scrollLeft
        const length = this.tleftWidth + tbody.clientWidth + rightLength
        let right = length - content.clientWidth + left
        right = right < 0 ? 0 : right
        this.clientRect = {
          top: top,
          left,
          right,
          bottom: 0,
        }
      } else if (!this.scrollTarget) {
        const { top, left, bottom, right } = tbody.getBoundingClientRect()
        let r = window.innerWidth - (right + this.tRightWidth)
        if (r > 0) {
          r = 0
        }
        this.clientRect = {
          top: top,
          left: left - this.tleftWidth,
          bottom,
          right: -r,
        }
      } else {
        const point = this.getPointOffsetParent()
        this.clientRect = {
          top: point.top,
          left: point.left,
          right: point.right,
          bottom: 0,
        }
      }

      let harr = []
      Array.from(document.querySelectorAll('.main-body .expand')).forEach(each => {
        harr.push(each.clientHeight)
      })
      let right = document.querySelectorAll('.right-body .expand')
      for (let i = 0; i < right.length; i++) {
        right[i].style.height = harr[i] + 'px'
      }
    },
    observerHandle: timerFnc(function() {
      this.update()
    }, 0),
    resizeHandel: timerFnc(
      function() {
        this.update()
        this.opacity = 1
      },
      0,
      function() {
        this.opacity = 0
      }
    ),
    update() {
      if (this._isDestroyed) {
        return
      }
      if (this.isFixLeft && this.$refs.leftClone) {
        this.tleftWidth = this.$refs.leftClone.clientWidth
      }
      if (this.isFixRight && this.$refs.rightClone) {
        this.tRightWidth = this.$refs.rightClone.clientWidth
      }
      if (this.$refs.content) {
        this.tbodyWidth =
          this.$refs.content.clientWidth -
          this.tleftWidth -
          (this.showFixedRight ? this.tRightWidth : 0)
      }
      this.$nextTick(() => {
        this.scrollHandle()
      })
    },
    transitionTop: timerFnc(function() {
      this.topChanging = false
    }, 0),
    transitionLeft: timerFnc(function() {
      this.leftChanging = false
    }, 0),
  },
  watch: {
    offsetLeft(val) {
      setTimeout(() => {
        this.scrollHandle()
      }, 250)
    },
    'clientRect.top': function(val, old) {
      this.fixed.top = val < 0
      if (val < 0 && this.isTransition) {
        this.topChanging = true
        this.transitionTop()
      }
    },
    'clientRect.left': function(val) {
      this.fixed.left = val < this.offsetLeft
      if (val < 0 && this.isTransition) {
        this.leftChanging = true
        this.transitionLeft()
      }
    },
  },
}
</script>

<style>
.scroll-container {
  overflow: auto;
}

body::-webkit-scrollbar,
.scroll-container::-webkit-scrollbar {
  width: 9px;
  height: 8px;
}

body::-webkit-scrollbar-track,
.scroll-container::-webkit-scrollbar-track {
  background: #eee;
}

body::-webkit-scrollbar-thumb,
.scroll-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

body::-webkit-scrollbar,
.scroll-container.bold::-webkit-scrollbar {
  width: 9px;
  height: 14px;
}

body::-webkit-scrollbar-thumb,
.scroll-container.bold::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.fixed-table {
  width: 100%;
  color: #333;
  background: #fff;
}

.fixed-table thead {
  background: #eff1f2;
}

.fixed-table td,
.fixed-table th {
  border: 1px solid #e3e3e9;
  font-size: 13px;
  padding: 4px 20px;
  box-sizing: border-box;
}

.fixed-table td.align-cell,
.fixed-table th.align-cell {
  height: 40px;
  line-height: 1.5;
}

.fixed-table td.align-cell span.tag,
.fixed-table th.align-cell span.tag {
  display: flex;
}

.fixed-table-container .table-clone tbody {
  background: unset !important;
}

.fixed-table tbody tr:hover,
.fixed-table tbody tr.hover {
  background: #eef0fc;
}

.fixed-table tbody tr.active {
  background: #eef0fc;
  color: #6a82ec;
}

.fixed-table th {
  width: auto;
  color: #68696b;
  height: 40px;
  white-space: nowrap;
  font-weight: normal;
  text-align: center;
  font-weight: 700;
}

.fixed-table td,
.fixed-table .cell {
  text-align: center;
  white-space: nowrap;
  min-height: 36px;
  line-height: 36px;
  width: auto;
}

.fixed-table-hide {
  position: absolute;
  top: 1px;
  right: 0px;
  z-index: 99;
  cursor: pointer;
  /* background: #eff1f2; */
  padding: 14px 5px 12px 5px;
}

.fixed-table-container {
  position: relative;
  z-index: 1;
  transform: translate3d(0, 0, 0);
  box-shadow: -1px 0px 0px 0px #dadada, 1px 0px 0px 0px #dadada, 0px 1px 0 0 #dadada;
  border-top: none;
  display: flex;
}

.fixed-table-container .table-clone {
  z-index: 999;
}

.fixed-table-container .table-clone tbody {
  background: lighten(#f1f2fe, 1.5%);
}

.fixed-table-container .table-clone.corner {
  z-index: 2;
}

.fixed-table-container .table-clone.left {
  box-shadow: 5px 0px 3px -3px #dadada;
}

.fixed-table-container .table-clone.right {
  box-shadow: -5px 0px 3px -3px #dadada;
}

.fixed-table-container .table-clone.right td {
  overflow: visible;
}

.fixed-table-container .fixed-table {
  border-spacing: 0px;
  border-collapse: separate;
  transform-style: preserve-3d;
}

.fixed-table-container .fixed-table th,
.fixed-table-container .fixed-table td {
  border-bottom: none;
  border-right: none;
  border-left: none;
  box-shadow: 1px 0 0 0 #dadada;
  max-width: 390px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fixed-table-container .fixed-table th .width-auto,
.fixed-table-container .fixed-table td .width-auto {
  max-width: unset;
}

.fixed-table-container .fixed-table thead.fixed {
  box-shadow: 0 1px 0 0 #dadada;
}

.fixed-table-container .fixed-table thead {
  z-index: 99;
}

.fixed-table-container .fixed-table tbody {
  transform: translate(0, 0);
}

.flex {
  display: flex;
}

.flex-grow {
  flex-grow: 1;
}

.rel {
  position: relative;
  /*  修复复合层造成translate3d元素闪动的问题 */
  z-index: 98;
}

.flex-no-shrink {
  flex-shrink: 0;
}
</style>
